import { BoxProps } from '@chakra-ui/react';

export const contributorThemeStyles = {
    minScreenHeight: '66dvh',
} satisfies {
    minScreenHeight: BoxProps['minH'];
};
